import script from "./DashboardAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&setup=true&lang=js"

import "./DashboardAdmin.vue?vue&type=style&index=0&id=ae5a636e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae5a636e"]])

export default __exports__